import { createStore, get, set, clear, del } from 'idb-keyval';
import { Logger } from 'simple-logging-lib';
import { getPortalId } from '../../../../utils/getPortalId';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../../constants/logging';
import { cachedDataIsValid } from './utils';
const SANDBOX_BANNER_CONFIG_DB_PATH = 'hs.sandbox-banner';
const SANDBOX_BANNER_CONFIG_STORE_NAME = 'hubspot-sandbox-banner-config';
export const IS_SANDBOX_PORTAL_STORE_KEY = 'is-sandbox-portal';
export const SANDBOX_DATA_STORE_KEY = 'sandbox-data';
let storeInstance;
const getStore = () => {
  const portalId = getPortalId();
  if (!portalId) return undefined;
  if (!storeInstance) {
    const dbName = `${SANDBOX_BANNER_CONFIG_DB_PATH}.${portalId}`;
    storeInstance = createStore(dbName, SANDBOX_BANNER_CONFIG_STORE_NAME);
  }
  return storeInstance;
};
export const sandboxBannerConfigStore = {
  get: async key => {
    try {
      const store = getStore();
      if (!store) {
        return undefined;
      }
      const config = await get(key, store);
      if (cachedDataIsValid(key, config)) {
        return config;
      }

      // If config is invalid, delete the key and return undefined
      if (config !== undefined) {
        await sandboxBannerConfigStore.delete(key);
      }
      return undefined;
    } catch (error) {
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error('Failed to get sandbox banner config from idb-keyval store', error);
      return undefined;
    }
  },
  set: async (key, config) => {
    try {
      const store = getStore();
      if (!store) {
        throw new Error('Unable to initialize idb-keyval store');
      }
      await set(key, config, store);
    } catch (error) {
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error('Failed to set sandbox banner config in idb-keyval store', error);
      throw error;
    }
  },
  delete: async key => {
    try {
      const store = getStore();
      if (!store) {
        return;
      }
      await del(key, store);
    } catch (error) {
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error(`Failed to delete sandbox banner config key (${key}) from idb-keyval store`, error);
    }
  },
  clear: async () => {
    try {
      const store = getStore();
      if (!store) {
        return;
      }
      await clear(store);
    } catch (error) {
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error('Failed to clear sandbox banner config from idb-keyval store', error);
    }
  }
};